<!-- day-view-mobile.component.html -->
<div class="dvm-container">
  <!-- Top Header -->
  <mat-toolbar class="dvm-header" color="primary">
    <span class="dvm-header-title">Day View</span>
    <span class="dvm-flex-spacer"></span>
    <button mat-icon-button [matMenuTriggerFor]="moreMenu">
      <mat-icon>more_vert</mat-icon>
    </button>
  </mat-toolbar>

  <div class="dvm-calendar-header">
    <button mat-icon-button (click)="navigateBackward()" aria-label="Previous">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <div class="dvm-calendar-title">
      <div class="dvm-calendar-date">{{ currentDate | date: 'EEE, d MMM, y' }}</div>
      <div class="dvm-calendar-subtitle">{{ studioName || 'The Oasis Salon' }}</div>
    </div>
    <button mat-icon-button (click)="navigateForward()" aria-label="Next">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>

  <!-- More Options Menu -->
  <mat-menu #moreMenu="matMenu">
    <button mat-menu-item (click)="openPrintDialog()">
      <mat-icon>print</mat-icon>
      <span>Print</span>
    </button>
    <button mat-menu-item (click)="openFilters()">
      <mat-icon>filter_list</mat-icon>
      <span>Filters</span>
    </button>
    <button mat-menu-item (click)="refreshCalendar()">
      <mat-icon>refresh</mat-icon>
      <span>Refresh</span>
    </button>
  </mat-menu>

  <!-- Current Instructor Info Bar -->
  <div class="dvm-instructor-info">
    <div class="dvm-instructor-name">
      <mat-icon>person</mat-icon>
      <app-instructor-toggle
        [instructors]="instructors"
        [mobileMode]="true"
        [selectedInstructorId]="selectedInstructorId"
        [storageScope]="instructorToggleStorageScope"
        (instructorSelected)="handleMobileInstructorSelection($event)">
      </app-instructor-toggle>
    </div>
    <div class="dvm-summary">
      <mat-chip-list>
        <mat-chip>
          <span class="dvm-summary-label">Today:</span>
          <span class="dvm-summary-value">{{ summaryCount.privateLessonDaily }}</span>
          <sup>{{ summaryCount.privateTakenLessonDaily }}</sup>
        </mat-chip>
        <mat-chip>
          <span class="dvm-summary-label">Week:</span>
          <span class="dvm-summary-value">{{ summaryCount.privateLessonWeekly }}</span>
          <sup>{{ summaryCount.privateTakenLessonWeekly }}</sup>
        </mat-chip>
      </mat-chip-list>
    </div>
  </div>

  <!-- Main Calendar Content Area -->
  <div class="dvm-calendar">
    <div class="dvm-calendar-wrapper">
      <div *ngIf="!studioTimezoneLoaded" class="text-center p-5">
        <mat-spinner diameter="40" style="margin: 0 auto;"></mat-spinner>
        <div style="margin-top: 12px;">Loading calendar...</div>
      </div>
      <full-calendar *ngIf="studioTimezoneLoaded" #calendar [options]="calendarOptions"></full-calendar>
    </div>
  </div>

  <!-- Bottom Navigation / Action Bar -->
  <mat-toolbar class="dvm-bottom-nav" color="primary">
    <button *ngIf="_permissionsService.canAccess('lessons_create')" mat-button class="dvm-nav-button" [matMenuTriggerFor]="newEventMenu" (menuOpened)="loadCoachingPackages()">
      <mat-icon>add</mat-icon>
      <span class="dvm-nav-label">New Event</span>
    </button>

    <button *ngIf="_permissionsService.canAccess('lessons_edit')" mat-button class="dvm-nav-button" [matMenuTriggerFor]="statusUpdateMenu">
      <mat-icon>update</mat-icon>
      <span class="dvm-nav-label">Status</span>
    </button>

    <button *ngIf="_permissionsService.canAccess('students_create')" mat-button class="dvm-nav-button" (click)="addInquiry()">
      <mat-icon>contact_phone</mat-icon>
      <span class="dvm-nav-label">Inquiry</span>
    </button>
  </mat-toolbar>

  <!-- New Event Menu -->
  <mat-menu #newEventMenu="matMenu">
    <button mat-menu-item (click)="addLesson()">
      <mat-icon>event</mat-icon>
      <span>Add Lesson</span>
    </button>
    <button mat-menu-item (click)="addGroupLesson()">
      <mat-icon>group</mat-icon>
      <span>Add Group Lesson</span>
    </button>
    <button mat-menu-item (click)="addService()">
      <mat-icon>room_service</mat-icon>
      <span>Add Service</span>
    </button>
    <button mat-menu-item (click)="addSchedule()">
      <mat-icon>schedule</mat-icon>
      <span>Add Schedule</span>
    </button>
    <button mat-menu-item [matMenuTriggerFor]="coachingMenu">
      <mat-icon>sports</mat-icon>
      <span>Add Coaching</span>
    </button>
    <button *ngIf="_permissionsService.canAccess('students_create')" mat-menu-item (click)="addInquiry()">
      <mat-icon>contact_phone</mat-icon>
      <span>Add Inquiry</span>
    </button>
  </mat-menu>

  <!-- Coaching packages submenu -->
  <mat-menu #coachingMenu="matMenu">
    <button mat-menu-item disabled *ngIf="coachingPackagesLoading">Loading…</button>
    <button mat-menu-item disabled *ngIf="!coachingPackagesLoading && coachingPackages.length === 0">No coaching packages</button>
    <button mat-menu-item *ngFor="let coachingPackage of coachingPackages" (click)="openCoachingLesson(coachingPackage, false)">
      {{ coachingPackage.name }}
    </button>
  </mat-menu>

  <!-- Status Update Menu -->
  <mat-menu #statusUpdateMenu="matMenu">
    <button mat-menu-item (click)="updateLesson()">
      <mat-icon>edit</mat-icon>
      <span>Update Lesson</span>
    </button>
    <button mat-menu-item (click)="updateGroupLesson()">
      <mat-icon>edit</mat-icon>
      <span>Update Group Lesson</span>
    </button>
    <button mat-menu-item (click)="updateService()">
      <mat-icon>edit</mat-icon>
      <span>Update Services</span>
    </button>
  </mat-menu>

  <!-- Tap-to-book popover (mirrors desktop day-view) -->
  <div *ngIf="_permissionsService.canAccess('lessons_edit')" #customPopover class="popover in bg-transparent border-0 shadow-none dvm-book-popover" role="tooltip" id="custom-popover" style="display: none;">
    <app-booking-menu
      [canBookLessons]="_permissionsService.canAccess('lessons_create')"
      [canAddInquiry]="_permissionsService.canAccess('students_create')"
      [coachingPackages]="coachingPackages"
      [coachingPackagesLoading]="coachingPackagesLoading"
      [openKey]="bookingMenuOpenKey"
      (choose)="onBookingMenuChoice($event)"
      (coachingChoose)="openCoachingLesson($event, true); hideCustomPopover();"
      (close)="hideCustomPopover()">
    </app-booking-menu>
  </div>
</div>
